/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import React, { Fragment } from 'react'
import { Modal } from 'antd-mobile'
import { Button, CloseBtn } from '@styles/button.style'
import { observer } from 'mobx-react'
import { Content, ModalBg } from '@styles/base.style'
import useRootStore from '@store/useRootStore'
import { Theme } from '@themes/theme'
import CouponCheck from '@views/Coupon/CouponCheck'

const CouponCheckPopup: React.FC = () => {
  const { globalStore } = useRootStore()
  const { visibleCouponCheckPopup } = globalStore

  const onCloseHandler = () => {
    globalStore.setVisibleCouponCheckPopup(false)
  }

  const modalClassName = 'full-modal message'
  const contentCss = (theme: Theme) => css`height: 100%; overflow: auto; text-align: left;`
  return (
    <Fragment>
      <Modal
        popup
        visible={visibleCouponCheckPopup}
        animated={false}
        title={
          <Fragment>
            <h1 className="title">쿠폰 확인</h1>
            <Button onClick={onCloseHandler} className="close-btn" css={CloseBtn}>
              <span className="close-txt">닫기</span>
            </Button>
          </Fragment>
        }
        className={modalClassName}
        onClose={onCloseHandler}
        maskClosable={false}
      >
        <Content css={contentCss}>
          <CouponCheck />
        </Content>

        <ModalBg onClick={onCloseHandler} />
      </Modal>
    </Fragment>
  )
}
export default observer(CouponCheckPopup)
